// Inner-page hero shared by all 14 sub-pages - video backdrop, eyebrow, headline, lede, CTA.
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

interface InnerHeroProps {
  video: string;
  eyebrow: string;
  headline: string;
  italicWord?: string;
  lede: string;
  ctaLabel?: string;
  ctaHref?: string;
}

export default function InnerHero({
  video,
  eyebrow,
  headline,
  italicWord,
  lede,
  ctaLabel = "Talk to an engineer",
  ctaHref = "/#contact",
}: InnerHeroProps) {
  return (
    <section className="min-h-screen bg-black relative overflow-hidden flex flex-col">
      <video
        className="hero-media"
        src={video}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        style={{ opacity: 1 }}
      />
      <div className="vignette" aria-hidden="true" />
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 py-12 text-center -translate-y-[12%] md:-translate-y-[15%]">
        <Reveal kind="reveal-soft" delay={0}>
          <div className="liquid-glass rounded-full px-4 py-1.5 text-white/70 text-xs tracking-widest uppercase inline-flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-white/80 pulse-dot" />
            {eyebrow}
          </div>
        </Reveal>
        <Reveal delay={120}>
          <h1 className="font-instrument text-5xl md:text-7xl text-white tracking-tight mt-6">
            {headline}
            {italicWord && (
              <> <em className="italic-serif text-white/60">{italicWord}</em></>
            )}
          </h1>
        </Reveal>
        <Reveal delay={240}>
          <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-2xl mt-6">{lede}</p>
        </Reveal>
        <Reveal delay={360}>
          <a
            href={ctaHref}
            className="mt-8 rounded-full px-8 py-3 text-black text-sm font-medium bg-white hover:bg-white/90 transition-colors inline-flex items-center gap-2"
          >
            {ctaLabel} <ArrowRight size={16} />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
